/** Reasons a login fails. The API redirects with the code, the web app shows a translated text. */
export const LOGIN_ERROR_CODES = [
  'account-locked',
  'cancelled',
  'company-unavailable',
  'flow-expired',
  'mfa-required',
  'provider-error',
  'provider-unavailable',
  'rate-limited',
  'sso-unavailable',
] as const;
export type LoginErrorCode = (typeof LOGIN_ERROR_CODES)[number];

/**
 * Reasons a step of the password login or of the password pages fails. The API answers with the
 * code in `message`, the web app shows a translated text.
 */
export const PASSWORD_ERROR_CODES = [
  'account-locked',
  'company-unavailable',
  'invalid-code',
  'invalid-credentials',
  'invalid-password',
  'invalid-token',
  'mfa-required',
  'no-password',
  'passkey-failed',
  'passkey-required',
  'passkey-unknown',
  'password-login-disabled',
  'password-too-long',
  'password-too-short',
  'rate-limited',
  'two-factor-expired',
  'two-factor-locked',
] as const;
export type PasswordErrorCode = (typeof PASSWORD_ERROR_CODES)[number];

/** Length limits of passwords (NIST SP 800-63B: length instead of composition rules). */
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;
